module.exports = __webpack_public_path__ + "static/media/new-loader-jet.d1a29cc1.webp";